/*
 * NOTE: Must maintain the order of enum items in CompanyUserStatus.java!
 */
export enum CompanyUserStatus {
    INVITED,
    ACTIVE,
    INACTIVE,
}
